import React from 'react';
import './Styles/CreateJobLoadingOverlay.css';

export default function CreateJobLoadingOverlay({ message, image = null, background = 'rgba(255,255,255,0.9)' }) {
    return (
        <div className="create-job-loading-overlay" style={{ background }}>
            {image && <img src={image} alt="Loading" className="create-job-loading-image" />}
            <div className="create-job-loading-text">{message}</div>
            <div className="create-job-loading-spinner" />
        </div>
    );
}
